export const CLIENT_ICP_TYPE_OPTIONS = [
  { value: 'consumer_brand', label: 'Consumer brand or DTC' },
  { value: 'funded_startup', label: 'VC-backed startup' },
  { value: 'b2b_services', label: 'Professional services or consultancy' },
  { value: 'media', label: 'Media or production company' },
  { value: 'agency', label: 'Agency' },
  { value: 'smb', label: 'Small business' },
  { value: 'enterprise', label: 'Enterprise or corporate' },
  { value: 'nonprofit', label: 'Nonprofit or NGO' },
  { value: 'other', label: 'Other' },
];

export const CLIENT_COMPANY_SIZE_OPTIONS = [
  { value: 'solo', label: 'Solo', subtitle: 'just me' },
  { value: '2_10', label: '2–10', subtitle: 'people' },
  { value: '11_50', label: '11–50', subtitle: 'people' },
  { value: '51_250', label: '51–250', subtitle: 'people' },
  { value: '251_plus', label: '251+', subtitle: 'people' },
];

export function getBuyerLoginPath() {
  return '/ats';
}
